// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c6931063","952":"79b33ca6"}[chunkId] + ".chunk.js";
};